import { showLinkInputPopup, removeAllLinkPopupDomNodes } from "./linkInputPopup.js";
import {
  applyEditorLink,
  getLinkReferenceRect,
  unsetEditorLink,
} from "./linkEditorUtils.js";

let activePopup = null;

function closeActivePopup() {
  if (activePopup) {
    activePopup.destroy?.();
    activePopup = null;
  }
  removeAllLinkPopupDomNodes();
}

/**
 * Opens the shared link URL popup for checkpoint / Notion editor flows.
 */
export function openEditorLinkPopup(editor, options = {}) {
  if (!editor?.view) {
    return null;
  }

  closeActivePopup();

  const initialUrl = options.initialUrl ?? editor.getAttributes("link").href ?? "";

  activePopup = showLinkInputPopup(
    editor,
    () => getLinkReferenceRect(editor),
    {
      initialUrl,
      allowUnset: options.allowUnset ?? true,
      onClose: () => {
        activePopup = null;
      },
      onSave: (href) => {
        if (typeof options.onSave === "function") {
          options.onSave(href);
          return;
        }

        if (href) {
          applyEditorLink(editor, href, { displayText: "link" });
        } else {
          unsetEditorLink(editor);
        }
      },
    }
  );

  return activePopup;
}

export function registerEditorLinkPickerHost() {
  if (typeof window === "undefined") {
    return;
  }

  window.__exiqOpenEditorLinkPopup = openEditorLinkPopup;
  window.__exiqApplyEditorLink = applyEditorLink;
  window.__exiqUnsetEditorLink = unsetEditorLink;
}
